export enum UserRole {
  USER = 'user',
  ADMIN = 'admin'
}

export enum UserOnBoardingStatus {
  WITHIN_15_MIN_HAS_GIFT_CARD = 'WITHIN_15_MIN_HAS_GIFT_CARD',
  WITHIN_15_MIN_HAS_NO_GIFT_CARD = 'WITHIN_15_MIN_HAS_NO_GIFT_CARD',
  OUTSIDE_15_MIN_HAS_GIFT_CARD = 'OUTSIDE_15_MIN_HAS_GIFT_CARD',
  OUTSIDE_15_MIN_HAS_NO_GIFT_CARD = 'OUTSIDE_15_MIN_HAS_NO_GIFT_CARD',
  NORMAL_LOGIN_STATUS = 'NORMAL_LOGIN_STATUS',
}
